import React from "react";
import { ImgTopBtn } from "../buttons";
import "./glassPopupModal.scss"; // assuming your SCSS is in this file

export default function GlassPopupModal({ children, onClose }) {
  return (
    <div className="modal-wrapper" onClick={onClose}>
      <div className="modalBody" onClick={(e) => e.stopPropagation()}>
      <ImgTopBtn
          id="close-btn"
          imgTopBtnBorderRadius="25px"
          imgTopBtnText=" X Close"
          imgTopBtnWidth="fit-content"
          imgTopBtnTextFontSize="1.3rem"
          imgTopBtnFontFamily="Roboto-Slab"
          imgTopBtnFontWeight="900"
          imgTopBtnFontColor="var(--color-bloodred)"
          paddingRight="5px"
          paddingLeft="5px"
          extraImgTopBtnStyles={{
            bottom: "20px",
            left: "10px",
          }}
          onClick={onClose} // Pass type and id to onCancel
        />
        <div className="content">
          {children}
        </div>
      </div>
    </div>
  );
}
